import { PersonArtistsType as ApiPersonArtistType } from 'src/api/generated/touring/types';
import { mapCategoriesWithArtists } from './helpers';
import { PersonArtistsType } from './types';

export const mapPersonArtistsResponseType = (
  apiType: ApiPersonArtistType[] | undefined
): PersonArtistsType[] => {
  if (!apiType) return [];

  return apiType.map((artist) => ({
    companyId: artist.companyId,
    categoriesWithArtists: mapCategoriesWithArtists(
      artist.categoriesWithArtists
    ),
  }));
};
